import { InlineComment } from '@amzn/awscat-pattern-library-service-model';

/** Whether a comment was authored by a scanner (not a human). */
export function isScannerComment(comment: InlineComment): boolean {
  return comment.authorType === 'SCANNER';
}
